import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ComicBase from "./ComicBase";
import ComicPagina from "./ComicPagina";
import ComicReader from "./ComicReader";
import BusquedaPrecisa from "./BusquedaPrecisa";
import Buscar from "./Buscar";
import Autores from "./Autores";
import Tags from "./Tags";
import Register from "./Registrarse/Register";
import Login from "./Registrarse/Login";
import ScrollToTop from "./ScrollToTop";

// =====================================================
// 🚀 AUTO-DETECCIÓN DE CÓMICS DESDE /pages
// =====================================================
const context = require.context("./pages", true, /\.jsx$/);

const comicsAuto = context
  .keys()
  .map((file, index) => {
    try {
      const mod = context(file);
      const info = mod.infoManga;
      const Component = mod.default;

      if (!info) return null;

      const enlace =
        info.enlace ||
        `/comic/${info.titulo
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/[^a-z0-9]/g, "")}`;

      return {
        id: index + 1,
        titulo: info.titulo,
        portada: info.portada,
        enlace,
        fecha: info.fecha,
        Component,
      };
    } catch (e) {
      console.error("❌ Error al cargar:", file, e);
      return null;
    }
  })
  .filter(Boolean);

// =====================================================
// 🚀 APP PRINCIPAL
// =====================================================
function App() {
  const comicsLista = comicsAuto
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    .map((m) => ({
      id: m.id,
      nombre: m.titulo,
      imagen: m.portada,
      enlace: m.enlace,
    }));

  return (
    <Router>
      <ScrollToTop />

      <Routes>
        {/* LOGIN */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* HOME + PAGINACIÓN */}
        <Route
          path="/"
          element={<ComicPagina comics={comicsLista} />}
        />

        <Route
          path="/page/:num"
          element={<ComicPagina comics={comicsLista} />}
        />

        {/* OTRAS RUTAS */}
        <Route path="/comic" element={<ComicBase />} />
        <Route path="/lector/:id" element={<ComicReader />} />
        <Route path="/busqueda-precisa" element={<BusquedaPrecisa />} />
        <Route path="/autores" element={<Autores comics={comicsLista} />} />
        <Route path="/tags" element={<Tags />} />
        <Route path="/buscar" element={<Buscar comics={comicsLista} />} />

        {/* CÓMICS AUTOMÁTICOS */}
        {comicsAuto.map((m, i) => (
          <Route key={i} path={m.enlace} element={<m.Component />} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;